<div class="container-fluid p-3">
  <div class="row">
    <div class="mb-4">
      <!-- Header section with buttons and title -->
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 flex-wrap">
        <!-- Title aligned to the right on larger screens -->
        <h4 class="m-0 text-md-end text-start text-color fs-24 fg-500">
          {{ 'TEST_MODE.EVALUATION' | translate }}
        </h4>
      </div>

      <!-- Tabs -->
      <div class="d-flex align-items-center border-bottom mb-3">
        <button class="tab-btn border-0 fs-16 fg-400 p-2"
          [class.active-tab]="activeTab === 'active'"
          (click)="activeTab = 'active'">
          {{ 'tests.active' | translate }}
        </button>
        <button class="tab-btn border-0 fs-16 fg-400 p-2"
          [class.active-tab]="activeTab === 'archived'"
          (click)="activeTab = 'archived'">
          {{ 'tests.archived' | translate }}
        </button>
      </div>

      <!-- Card with data table -->
      <div class="mt-3">
        <div *ngIf="activeTab === 'active'">
          <app-student-tests [testMode]="'evaluation'" />
        </div>
        <div *ngIf="activeTab === 'archived'">
          <div class="text-muted text-center py-4">
            {{ 'tests.noArchived' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>